import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asset-control',
  templateUrl: './asset-control.component.html',
  styleUrls: ['./asset-control.component.scss']
})
export class AssetControlComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
